import ErrorFallback from 'Components/ErrorFallback'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'
import { TicketDetailPage, TicketListPage } from './Pages'

const AffiliateProductRoot = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<TicketListPage />} />
        <Route path={`:id`} element={<TicketDetailPage />} />
      </Routes>
    </ErrorBoundary>
  )
}
export default AffiliateProductRoot
